import React, { useContext, useEffect, useState, useRef } from "react";
import AuthContext from "context/AuthContext";
import refreshAccessToken from 'adminRefresToken';
import getCSRFToken from 'csrftoken';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// HG Pro components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftButton from "components/SoftButton";
import EditFormPopup from "layouts/profile/components/EditFormPopup";
import SoftInput from "components/SoftInput";

// HG Pro examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";
import ProfilesList from "examples/Lists/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";
import PlaceholderCard from "examples/Cards/PlaceholderCard";

// Overview page components
import Header from "layouts/profile/components/Header";
import PlatformSettings from "layouts/profile/components/PlatformSettings";

// HG Pro icons
import Cube from "examples/Icons/Cube";
import Document from "examples/Icons/Document";
import Settings from "examples/Icons/Settings";

// HG Pro base styles
import breakpoints from "assets/theme/base/breakpoints";

// Images
import bruce from "assets/images/bruce-mars.jpg";
import curved0 from "assets/images/curved-images/curved0.jpg";
import homeDecor1 from "assets/images/home-decor-1.jpg";
import homeDecor2 from "assets/images/home-decor-2.jpg";
import homeDecor3 from "assets/images/home-decor-3.jpg";
import team1 from "assets/images/team-1.jpg";
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";
import { api } from "utils/Api";
import ChangePasswordPopup from "layouts/authentication/change-password/ChangePasswordPopup";

function Overview() {

  const { authTokens, staffauthTokens, managerauthTokens, logoutUser } = useContext(AuthContext);

  const selectedAuthToken = managerauthTokens || staffauthTokens || authTokens;

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [profiledata, setProfileData] = useState(null);

  const [userToEdit, setUserToEdit] = useState(null);


  useEffect(() => {
    fetchData();
  }, []);

  // const getCSRFToken = () => {
  //   const name = 'csrftoken';
  //   const value = `; ${document.cookie}`;
  //   //console.log(value);
  //   const parts = value.split(`; ${name}=`);
  //   if (parts.length === 2) return parts.pop().split(';').shift();
  // };

  // Fetch data from the API
  const fetchData = async () => {
    try {
      const response = await api.user.getUserSelf();
      setProfileData(response); // Set the fetched data in the state
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  return (
    <DashboardLayout>
      <SoftBox position="relative">
        <DashboardNavbar absolute light />
        <SoftBox
          display="flex"
          alignItems="center"
          position="relative"
          minHeight="18.75rem"
          borderRadius="xl"
          sx={{
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.info.main, 0.6),
                rgba(gradients.info.state, 0.6)
              )}, url(${curved0})`,
            backgroundSize: "cover",
            backgroundPosition: "50%",
            overflow: "hidden",
          }}
        />
        <Card
          sx={{
            backdropFilter: `saturate(200%) blur(30px)`,
            backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 0.8),
            boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
            position: "relative",
            mt: -8,
            mx: 3,
            py: 2,
            px: 2,
          }}
        >
          <Grid container spacing={3} alignItems="center">
            {profiledata && (
              <>
                <Grid item>
                  <SoftAvatar
                    src={profiledata.image ? `https://hgpro.nyc${profiledata.image}` : bruce}
                    alt="profile-image"
                    variant="rounded"
                    size="xl"
                    shadow="sm"
                  />
                </Grid>
                <Grid item>
                  <SoftBox height="100%" mt={0.5} lineHeight={1}>
                    <SoftTypography variant="h5" fontWeight="medium">
                      {profiledata.first_name} {profiledata.last_name}
                    </SoftTypography>
                    {/* <SoftTypography variant="button" color="text" fontWeight="medium">
                      {profiledata.user.is_superuser ? "Admin" : profiledata.user.is_staff ? "Manager" : "User"}
                    </SoftTypography> */}
                  </SoftBox>
                </Grid>
              </>
            )}
          </Grid>
        </Card>
      </SoftBox>

      <SoftBox mt={5} mb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} xl={12}>
            <Card>
              <div style={{ padding: "15px" }}>
                <div>
                  <h4 style={{ display: "inline-block" }}>Profile Information</h4>
                  <SoftButton
                    style={{ float: "right", border: "none" }}
                    variant="gradient"
                    color="dark"
                    type="submit"
                    small
                    onClick={() => setUserToEdit(profiledata)}
                  >
                    Edit
                  </SoftButton>
                  <SoftButton
                    style={{ float: "right", border: "none", marginRight: "10px" }}
                    variant="gradient"
                    color="dark"
                    type="submit"
                    small
                    onClick={() => setIsPopupOpen(true)}
                  >
                    Change Password
                  </SoftButton>
                </div>
                {/* {profiledata && (
                  <>
                    <div>
                      <SoftTypography variant="button" fontWeight="regular" textGradient>
                        User Name : {profiledata.user.username} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography variant="button" fontWeight="regular" textGradient>
                        Password : ******* &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography variant="button" fontWeight="regular" textGradient>
                        Email Address : {profiledata.user.email} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography variant="button" fontWeight="regular" textGradient>
                        Home Phone : {profiledata.telephone_number} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        Cell Phone :  {profiledata.phone_number} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        Address :  {profiledata.address} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        Street Address : {profiledata.street_address} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        City :   {profiledata.city} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        State : {profiledata.state} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        Zip  Code : {profiledata.zip_code} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        Emergency  Phone : {profiledata.emergency_contact} &nbsp;
                      </SoftTypography>
                    </div>
                    <div>
                      <SoftTypography
                        variant="button"
                        fontWeight="regular"
                        textGradient
                      >
                        Last login by this IP : {profiledata.ip} &nbsp;
                      </SoftTypography>
                    </div>
                  </>
                )} */}
              </div>
              {profiledata && (
                <form style={{ margin: "10px" }}>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        User Name
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="username"
                      placeholder="Username"
                      value={profiledata.username}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        First Name
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="first_name"
                      placeholder="First Name"
                      value={profiledata.first_name}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Last Name
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="last_name"
                      placeholder="Last Name"
                      value={profiledata.last_name}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Email
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={profiledata.email}
                      disabled
                    />
                  </SoftBox>
                  {/* <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Home Phone
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="home_phone"
                      placeholder="Home Phone"
                      value={profiledata.telephone_number}
                      disabled
                    />
                  </SoftBox> */}
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Cell Phone
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="cell_phone"
                      placeholder="Cell Phone"
                      value={profiledata.phone_number}
                      disabled
                    />
                  </SoftBox>
                  {/* <SoftBox mb={2}>
                    <SoftTypography
                      variant="button"
                      fontWeight="bold"
                      textGradient
                    >
                      Profile picture &nbsp;
                    </SoftTypography>
                    <SoftTypography
                      variant="button"
                      fontWeight="regular"
                    >
                      &nbsp;&nbsp; Supported files JPG, JPEG, PNG of up to 4MB &nbsp;
                    </SoftTypography>
                    <SoftInput type="file" accept="image/*" name="image" />
                  </SoftBox> */}
                  {/* <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Address
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="address"
                      placeholder="Address"
                      value={profiledata.address}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Street Address
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="street_address"
                      placeholder="Street Address"
                      value={profiledata.street_address}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        City
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="city"
                      placeholder="City"
                      value={profiledata.city}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        State
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="state"
                      placeholder="State"
                      value={profiledata.state}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Zip Code
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="number"
                      name="zip_code"
                      placeholder="Zip Code"
                      value={profiledata.zip_code}
                      disabled
                    />
                  </SoftBox>
                  <SoftBox mb={2}>
                    <SoftBox mb={1} ml={0.5}>
                      <SoftTypography component="label" variant="caption" fontWeight="bold">
                        Emergency Phone
                      </SoftTypography>
                    </SoftBox>
                    <SoftInput
                      type="text"
                      name="emergency_phone"
                      placeholder="Emergency Phone"
                      value={profiledata.emergency_contact}
                      disabled
                    />
                  </SoftBox> */}
                </form>
              )}
            </Card>

            {userToEdit && (
              <EditFormPopup
                user={userToEdit}
                onSave={() => {
                  setUserToEdit(null); // Reset the userToEdit state after saving the changes
                  fetchData(); // Fetch updated user data after saving the changes
                }}
                onClose={
                  () => {
                    setUserToEdit(null);
                    fetchData();
                  } // Reset the userToEdit state if the edit is canceled
                }
              />
            )}

            {isPopupOpen && <ChangePasswordPopup onClose={() => setIsPopupOpen(false)} />}
          </Grid>
        </Grid>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
